export default __webpack_public_path__ + "static/media/asana_icon.145e041c.svg";